(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.modal.event
  (:require
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::show-modal
 (fn [{db :db} [_ show-path]]
   {:db (assoc-in db show-path true)}))

(rf/reg-event-fx
 ::hide-modal
 (fn [{db :db} [_ uploads-path]]
   {:db (assoc-in db uploads-path nil)}))